import Core from '../plugin-core-system/core.class.js';

export default class CsFlipText extends Core {

  togglePanel(panel, open) {
    this.el.setAttribute('aria-expanded', open);

    if (open) {
      panel.removeAttribute('hidden');
      panel.focus();
    } else {
      panel.setAttribute('hidden', '');
      this.el.focus();
    }
  }

  init() {
    const panelId = this.el.getAttribute('aria-controls');
    const panel = document.getElementById(panelId);

    this.el.addEventListener('click', () => {
      this.togglePanel(panel, true);
    });

    document.addEventListener('keydown', (e) => {
      if (this.el.getAttribute('aria-expanded') === 'true') {
        if (e.key === 'Escape' || e.key === 'Enter') {
          this.togglePanel(panel, false);
        }
      }
    });

    panel.addEventListener('click', () => {
      this.togglePanel(panel, false);
    });
  }
}
